module.exports = __webpack_public_path__ + "img/what-is-nano-id.af5fe1cd.jpg";